import React from 'react'
import { css } from '@emotion/core'
import { func, string } from 'prop-types'
import imgMale from './images/profileMale.svg'
import imgFemale from './images/profileFemale.svg'
import imgUnknown from './images/profileUnknown.svg'
import { getGender } from '../../helpers/person_Helper'

export default function ProfileImage({ gender, name, userImage, border, diameter, setShowPersonViewer }) {
  gender = getGender(gender)
  const getZionStyle = (k) =>
    ({
      colorWhite: '#ffffff',
      colorBlack: '#000000',
      colorBlueGenderLight: '#7DE3F4',
      colorPinkGenderLight: '#FC4E6D',
      colorGrayGenderLight: '#ccccc4',
      colorBlueGender: '#99c4fe',
      colorPinkGender: '#f48eb6',
      colorGrayGender: '#ccccc4',
      fontSizeSmall: '14px',
    }[k] || '')

  const getGenderColor = (g) =>
    ({
      male: getZionStyle('colorBlueGenderLight'),
      female: getZionStyle('colorPinkGenderLight'),
      unknown: getZionStyle('colorGrayGenderLight'),
    }[g] || getZionStyle('colorGrayGenderLight'))

  const cssProfileImage = () => css`
    width: ${diameter || '100%'};
    height: ${diameter || '100%'};
    max-width: 150px;
    max-height: 150px;
    border: ${border};
    border-radius: 50%;
    background-color: ${getGenderColor(gender)};
    @media screen and (min-width: 320px) and (max-width: 823px) and (orientation: landscape) {
      max-width: 90px;
      max-height: 90px;
    }
  `

  const cssPersonViewerBtn = css`
    background: transparent;
    border: none;
    &:hover {
      cursor: pointer;
    }
  `

  const getDefaultImage = () => {
    let src
    if (gender === 'male') {
      src = imgMale
    } else if (gender === 'female') {
      src = imgFemale
    } else {
      src = imgUnknown
    }
    return src
  }

  const getPersonImage = () => {
    let src = imgUnknown

    if (userImage) {
      src = userImage
    } else {
      src = getDefaultImage()
    }

    const imageErrorHandler = (e) => {
      e.target.src = getDefaultImage()
    }
    return setShowPersonViewer ? (
      <button css={cssPersonViewerBtn} type="button" onClick={() => setShowPersonViewer(true)}>
        <img css={cssProfileImage} onError={imageErrorHandler} src={src} alt={name} />
      </button>
    ) : (
      <img css={cssProfileImage} onError={imageErrorHandler} src={src} alt={name} />
    )
  }

  return <div css={{ display: 'flex', justifyContent: 'center' }}>{getPersonImage(gender)}</div>
}
ProfileImage.propTypes = {
  gender: string.isRequired,
  name: string,
  userImage: string,
  border: string,
  diameter: string,
  setShowPersonViewer: func,
}
